import Vue from 'vue'
import { VueTable, Iterable } from '../interfaces'

export const tableHandler = <T>() =>
  Vue.extend({
    data() {
      return {
        editedItem: null as null | T,
        dialogModel: false,
        filter: {},
        detailItem: null as null | T,
        detailDialogModel: false,
        lastFilter: {},
      }
    },
    computed: {
      table(): VueTable {
        if (this.$refs.table) {
          return this.$refs.table as VueTable
        } else return {} as VueTable
      },
    },
    methods: {
      onNew(item: T): void {
        if (this.editedItem) {
          this.table.editItem(item)
          this.editedItem = null
        } else this.table.addItem(item)
      },
      onEdit(item: T): void {
        this.editedItem = item
        this.dialogModel = true
      },
      onCopy(item: T): void {
        const newItem: T = JSON.parse(JSON.stringify(item))
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (newItem.uuid) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          delete newItem.uuid
        }
        this.editedItem = newItem
        this.dialogModel = true
      },
      onCreate(): void {
        this.editedItem = null
        this.dialogModel = true
      },
      async newFilter(payload: Iterable): Promise<void> {
        this.lastFilter = payload
        await this.table.newFilter(payload)
      },
      onDetail(item: T) {
        this.detailItem = item
        this.detailDialogModel = true
      },
      onRefresh() {
        this.table.refresh()
      },
    },
  })
